import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

export default ({ store }) => {
  const configuration = store.getters['cms/configuration']
  const recaptcha = configuration.recaptcha
  if (!recaptcha?.siteKey) {
    return
  }

  Vue.use(VueReCaptcha, {
    siteKey: recaptcha.siteKey,
    loaderOptions: {
      autoHideBadge: false,
      useRecaptchaNet: true,
    },
  })
}
